import * as React from "react";
import { CustomFilterRenderProps } from "./ScrollableTableHeader";
import { FilterFilled, FilterOutlined } from "@ant-design/icons";
import { Popover } from "antd";
import { stopPropagation } from "./FiltersDropdown";
import { getFilterPopupContainer } from "./filterPopupContainer";

interface CustomFilterProps extends Omit<CustomFilterRenderProps, "confirm" | "clearFilters" | "setFilters"> {
  renderFunction: (renderProps: CustomFilterRenderProps) => React.ReactNode;
  filterIconDataTestId?: string;
}

export const CustomFilter = (props: CustomFilterProps) => {
  const [visible, setVisible] = React.useState(false);
  const [savedFilters, setFilters] = React.useState(null);
  const { renderFunction, filterIconDataTestId, ...restProps } = props;
  const clearFilters = () => {
    setVisible(false);
    restProps.onFilter([]);
  };
  const confirm = () => {
    setVisible(false);
    restProps.onFilter(savedFilters);
  };
  const hasNoFilters = !props.selectedFilters || !props.selectedFilters.length;

  React.useEffect(() => {
    if (props.selectedFilters) {
      if (savedFilters && props.selectedFilters.toString() === savedFilters.toString()) {
        return;
      } else {
        setFilters(props.selectedFilters);
      }
    }
  }, [props.selectedFilters]);

  const content = <div className="mb-sm">{renderFunction({ ...restProps, clearFilters, confirm, setFilters })}</div>;

  return (
    <div onClick={stopPropagation}>
      <Popover
        open={visible}
        onOpenChange={setVisible}
        trigger="click"
        placement="bottom"
        content={content}
        getPopupContainer={(node) => getFilterPopupContainer(node as HTMLElement)}
      >
        <div className="filter-icon" data-testid={filterIconDataTestId} role="button" tabIndex={0}>
          {hasNoFilters ? <FilterOutlined /> : <FilterFilled />}
        </div>
      </Popover>
    </div>
  );
};
